declare const __BUILD_TIMESTAMP__: number;
declare const __BUILD_VERSION__: string;

const buildTimestamp = __BUILD_TIMESTAMP__;
const buildVersion = __BUILD_VERSION__;

export default {
  version: buildVersion,
  timestamp: buildTimestamp,
};
